import { render, staticRenderFns } from "./customer-bank-accounts.vue?vue&type=template&id=68a4b2b5&scoped=true&"
import script from "./customer-bank-accounts.vue?vue&type=script&lang=js&"
export * from "./customer-bank-accounts.vue?vue&type=script&lang=js&"
import style0 from "./customer-bank-accounts.vue?vue&type=style&index=0&id=68a4b2b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a4b2b5",
  null
  
)

export default component.exports